export default __webpack_public_path__ + "static/media/point.e4c91671.svg";